import { Injectable, inject } from '@angular/core';

import { first, switchMap } from 'rxjs';
import { ChallengeParams } from '../interface/auth/challenge-params';
import { LoginParams } from '../interface/auth/login-params';

import { RegistrationRequestFieldModel } from '../interface/auth/user-registration-model';
import { AUTH_MANAGER_BASE_TOKEN } from '../misc/injection-tokens';

@Injectable({
    providedIn: 'root',
})
export class AuthAppService {
    private readonly authManagerService = inject(AUTH_MANAGER_BASE_TOKEN);

    // Auth Proccess state, status, error messages etc...
    // This proccess state is used by UI to display different steps (U/PW or U/OTP etc...)
    public authState$ = this.authManagerService.authState$;
    public realm$ = this.authManagerService.realm$;
    public chalengeParams$ = this.authManagerService.chalengeParams$;

    public initAfterAppInitializer() {
        return this.authManagerService.initiateLogin?.();
    }

    // In case of OTP this step triggers OTP generation;
    // In case of basicAuth, this step imediatly completes and skips challenge proccess step
    public challenge(params: ChallengeParams) {
        // TODO - Add logic to check settings / state etc..
        // This is only happy path
        return this.authManagerService.authState$.pipe(
            first(),
            switchMap(() => {
                return this.authManagerService.challenge(params);
            }),
        );
    }

    public login(params: LoginParams) {
        return this.authManagerService.login(params).pipe(switchMap(() => this.authState$.pipe(first())));
    }

    public logout() {
        return this.authManagerService.logout().pipe(switchMap(() => this.authState$.pipe(first())));
    }

    public register(params: RegistrationRequestFieldModel[]) {
        return this.authManagerService.register(params);
    }

    public getRegistrationFields() {
        return this.authManagerService.getRegistrationFields();
    }

    public getUserInfo() {
        return this.authManagerService.userInfoData$();
    }
}
